import { render, staticRenderFns } from "./LandingPageEditorFaqEditor.vue?vue&type=template&id=705371fc"
import script from "./LandingPageEditorFaqEditor.vue?vue&type=script&lang=js"
export * from "./LandingPageEditorFaqEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports